<div class="p-inputnumber-wrapper mat-mdc-form-field" [class]="inputClass" [class.disabled]="readonly">
  <label [class.required]="label && isRequired">
    {{ label }}
    @if (tooltip) {
      <i class="icon icon-info ic-secondary ml-5" [matTooltip]="tooltip"></i>
    }
  </label>

  <p-inputNumber (onInput)="onInput.emit($event.value)"
    [inputId]="inputId"
    [formControl]="ngControl.control"
    [placeholder]="placeholder"
    [min]="min"
    [max]="max"
    [inputStyleClass]="inputStyleClass"
    [required]="isRequired"
    class="w-100"
    [mode]="mode"
    currency="AUD"
    [prefix]="prefix"
    [maxFractionDigits]="maxFractionDigits"
    [readonly]="readonly"
    locale="en-AU">
  </p-inputNumber>

  <div class="mat-mdc-form-field-subscript-wrapper m-0">
    <mat-error>
      @if (ngControl.touched) {
        <app-validation-error [errors]="ngControl.errors"></app-validation-error>
      }
    </mat-error>
  </div>
</div>
